import { render, staticRenderFns } from "./RideView.vue?vue&type=template&id=61517148&scoped=true&"
import script from "./RideView.vue?vue&type=script&lang=js&"
export * from "./RideView.vue?vue&type=script&lang=js&"
import style0 from "./RideView.vue?vue&type=style&index=0&id=61517148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61517148",
  null
  
)

export default component.exports